<template>
  <div class="footer">
    <p>傲为科技版权所有 2018-现在</p>
    <p>Copyright © 2019-广州傲为信息技术有限公司 ALLRight Reserved 粤ICP00000000号</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/custom.scss";
.footer {
  width: 100%;
  padding: 10px 0;
  background: $dark-color;
  text-align: center;

  p {
    margin: 0px;
    font-size: 12px;
    color: $white-color;
  }
}
</style>
